@switch (headingLevel) {
  @case ('h2') {
    <h2 class="font-semibold my-4 title text-dark-purple {{additionalClasses}}">{{title}}</h2>
  }
  @case ('h3') {
    <h3 class="font-semibold my-4 title text-dark-purple {{additionalClasses}}">{{title}}</h3>
  }
  @case ('h4') {
    <h4 class="font-semibold my-4 title text-dark-purple {{additionalClasses}}">{{title}}</h4>
  }
  @default {
    <h1 class="font-semibold my-4 title text-dark-purple {{additionalClasses}}">{{title}}</h1>
  }
}

